@if (formControl) {
  <div
    class="input-color"
    [class.input-color--error]="hasError"
  >
    <label
      class="input-color__swatch-btn"
      [for]="id + '-picker'"
      aria-label="Abrir seletor de cor"
    >
      <span
        class="input-color__swatch"
        [style.background-color]="swatchColor()"
      ></span>
      <input
        class="input-color__picker"
        [id]="id + '-picker'"
        type="color"
        [value]="pickerValue()"
        [disabled]="formControl.disabled || disabled"
        (input)="onPickerInput($event)"
        tabindex="-1"
        aria-hidden="true"
      />
    </label>

    <input
      class="input-color__field"
      [class.input-color__field--error]="hasError"
      [id]="id"
      type="text"
      inputmode="text"
      autocomplete="off"
      spellcheck="false"
      [placeholder]="placeholder"
      [formControl]="formControl"
      (blur)="onBlur()"
    />
  </div>
} @else {
  <div
    class="input-color"
    [class.input-color--error]="hasError"
  >
    <label class="input-color__swatch-btn" aria-label="Seletor de cor">
      <span class="input-color__swatch"></span>
    </label>

    <input
      class="input-color__field"
      [class.input-color__field--error]="hasError"
      [id]="id"
      type="text"
      inputmode="text"
      autocomplete="off"
      spellcheck="false"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (blur)="onBlur()"
    />
  </div>
}
